module.exports = __webpack_public_path__ + "img/coffee-colored-icon.4eeb37f8.svg";